import { MONTHLY_TOKEN_BUDGET_MAX } from '@rp/contracts'
import { useState } from 'react'
import { Field } from '../../design'
import { LOCALE } from '../../lib/time'
import { USAGE_COPY } from './copy'

const WHOLE_NUMBER = /^\d+$/

export const TOKEN_BUDGET_FIELD_ID = 'usage-token-budget'

const groupedFormat = new Intl.NumberFormat(LOCALE)
const INVALID_BUDGET = USAGE_COPY.monthlyTokenBudgetInvalid(groupedFormat.format(MONTHLY_TOKEN_BUDGET_MAX))

export const parseTokenBudget = (text: string): number | null => {
  const trimmed = text.trim()
  if (!WHOLE_NUMBER.test(trimmed)) return null
  const budget = Number(trimmed)
  return budget <= MONTHLY_TOKEN_BUDGET_MAX ? budget : null
}

export const TokenBudgetField = ({
  budget,
  onChange,
}: {
  budget: number
  onChange: (budget: number | null) => void
}) => {
  const [loadedBudget] = useState(budget)
  const loadedText = String(loadedBudget)
  const [text, setText] = useState(loadedText)
  const budgetOf = (value: string) => (value === loadedText ? loadedBudget : parseTokenBudget(value))
  const current = budgetOf(text)
  const invalid = current === null

  return (
    <Field
      id={TOKEN_BUDGET_FIELD_ID}
      label={USAGE_COPY.monthlyTokenBudget}
      hint={USAGE_COPY.monthlyTokenBudgetHint}
      {...(invalid ? { error: INVALID_BUDGET } : {})}
    >
      {({ id, describedBy }) => (
        <>
          <input
            id={id}
            className="usage-budget-input"
            aria-describedby={describedBy}
            aria-invalid={invalid}
            type="number"
            inputMode="numeric"
            min={0}
            max={MONTHLY_TOKEN_BUDGET_MAX}
            step={1}
            value={text}
            onChange={(event) => {
              setText(event.target.value)
              onChange(budgetOf(event.target.value))
            }}
          />
          {current === null ? null : (
            <p className="field-hint num" aria-live="polite">
              {USAGE_COPY.monthlyTokenBudgetGrouped(groupedFormat.format(current))}
            </p>
          )}
        </>
      )}
    </Field>
  )
}
